import { createStore, createTypedHooks } from 'easy-peasy'
import rates, { RatesModel } from './rates'
import auth, { AuthModel } from './auth'
import ui, { UIModel } from './ui'
import advertisers, { AdvertisersModel } from './advertisers'
import products, { ProductsModel } from './products'
import markets, { MarketsModel } from './markets'
import users, { UsersModel } from './users'
import indexes, { IndexesModel } from './indexes'

export interface StoreModel {
  indexes: IndexesModel
  products: ProductsModel
  markets: MarketsModel
  advertisers: AdvertisersModel
  rates: RatesModel
  users: UsersModel
  auth: AuthModel
  ui: UIModel
}

const model: StoreModel = {
  indexes,
  products,
  markets,
  advertisers,
  rates,
  users,
  auth,
  ui
}

const store = createStore(model, {
  name: 'rates-research-store'
})

export default store

export const { useStoreState, useStoreActions, useStoreDispatch } =
  createTypedHooks<StoreModel>()
